/** Inline loading indicator, ported from the `.spin` rule of the old pages. */

import type { ReactNode } from 'react';

export interface SpinnerProps {
  /** `on-accent` renders the white variant used inside filled buttons. */
  variant?: 'default' | 'on-accent';
  /** `lg` is the page-level spinner. */
  size?: 'sm' | 'lg';
  /** Accessible label; defaults to the German 'Lädt…'. */
  label?: string;
}

export function Spinner({ variant = 'default', size = 'sm', label = 'Lädt…' }: SpinnerProps): ReactNode {
  const classes = ['spin'];
  if (variant === 'on-accent') classes.push('on-accent');
  if (size === 'lg') classes.push('lg');
  return <span className={classes.join(' ')} role="status" aria-label={label} />;
}

export interface PageSpinnerProps {
  /** German text shown below the spinner. */
  text?: string;
}

/** Full-height loading state for route transitions and initial loads. */
export function PageSpinner({ text = 'Lädt…' }: PageSpinnerProps): ReactNode {
  return (
    <div className="loading-page">
      <Spinner size="lg" label={text} />
      <span>{text}</span>
    </div>
  );
}

export default Spinner;
